import React, { Component } from 'react'
import { get } from 'lodash'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import queryString from 'query-string'

@withRouter
@connect(({ auth }) => ({
  user: auth.user
}))
class FileLink extends Component {
  static propTypes = {
    src: PropTypes.string,
    icoClass: PropTypes.string,
    typeClass: PropTypes.string,
    intlKey: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
    fileName: PropTypes.string,
    location: PropTypes.object,
    user: PropTypes.object,
    withCode: PropTypes.bool
  }

  render() {
    const {
      src,
      user,
      icoClass,
      withCode,
      typeClass,
      type,
      fileName
    } = this.props

    let suffix = ''
    let authorizationCode = ''

    if (!src) {
      return null
    }

    const operator = src.includes('?') ? '&' : '?'

    if (withCode) {
      const query = queryString.parse(get(this.props, 'location.search'))
      authorizationCode = get(query, 'authorizationCode')
    }

    if (get(user, 'blobAccessAuthorizationCode')) {
      authorizationCode = user.blobAccessAuthorizationCode
    }

    suffix = `${operator}authorizationCode=${authorizationCode}`

    return (
      <a
        href={`${src}${suffix}`}
        target="_blank"
        style={{ textDecoration: 'none' }}
      >
        <span className={typeClass}>
          {icoClass && (
            <span
              className={`ico ico--file-other ico--file-${type} ${icoClass}`}
            />
          )}
          {fileName || ''}.{type}
        </span>
      </a>
    )
  }
}

export default FileLink
